import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { PlatformInformationService } from '../../../../projects/platform-manager/src/lib/services/platform-information.service';

@Injectable({
  providedIn: 'root'
})
export class PartnerLinkService {
  constructor(private platformInformationService: PlatformInformationService) {}

  getUrlWithPartner(prefix, postfix = ''): string {
    if (this.platformInformationService.getCurrentPartner()) {
      return Location.joinWithSlash(
        Location.joinWithSlash(prefix, this.platformInformationService.getCurrentPartner()),
        postfix
      );
    } else {
      return Location.joinWithSlash(prefix, postfix);
    }
  }

  /**
   *
   * @param url your complete url
   * @param prefix the part BEFORE partner-sport-brugger
   */
  getUrlReplacingPartnerAfterPrefix(url, prefix, partner = ''): string {
    if (this.platformInformationService.getCurrentPartner()) {
      return url.replace(prefix, prefix + '/' + this.platformInformationService.getCurrentPartner());
    } else if (partner) {
      return url.replace(prefix, prefix + '/' + 'partner-' + partner.replace('partner-', ''));
    } else {
      return url;
    }
  }
}
